import { render, staticRenderFns } from "./YwfzqkdjEdit.vue?vue&type=template&id=f0bca988&scoped=true"
import script from "./YwfzqkdjEdit.vue?vue&type=script&lang=js"
export * from "./YwfzqkdjEdit.vue?vue&type=script&lang=js"
import style0 from "./YwfzqkdjEdit.vue?vue&type=style&index=0&id=f0bca988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bca988",
  null
  
)

export default component.exports